import angular from 'angular';

/**
 * Controla la directiva "contenedor-comentarios"
 */
ContenedorComentariosCtrl.$inject = ['$log', 'Incidencia'];
export default function ContenedorComentariosCtrl($log, Incidencia) {

    var vm = this;

    vm.tareaSeleccionada = null;


    vm.isActiveTab = function (tarea) {
        return tarea == vm.tareaSeleccionada;
    };

    vm.selectTab = function (tab) {
        vm.tareaSeleccionada = tab;
    };

    vm.actualizar = function (incidenciaId) {
        cargarIncidencia(incidenciaId);
    };

    cargarIncidencia(vm.incidenciaId);

    function cargarIncidencia(incidenciaId) {
        vm.cargandoIncidencia = true;
        vm.incidencia = null;
        $log.debug('Cargando incidencia ' + incidenciaId);
        Incidencia.get({
            incidenciaId: incidenciaId,
            include: 'imagenes,tipos,obras'
        }, function (incidencia) {
            vm.incidencia = incidencia;
            seleccionarPrimeraTarea();
            vm.cargandoIncidencia = false;
        });
    }

    function seleccionarPrimeraTarea() {
        if (angular.isArray(vm.incidencia.obras) && vm.incidencia.obras.length > 0)
            vm.tareaSeleccionada = vm.incidencia.obras[0].codigo;
    }
}